/* eslint-disable react/no-array-index-key */
import NavLink from '@/components/elements/NavLink';

// components
import BottomNavigation from '@/components/elements/BottomNavigation';
import { SidebarMenuItem } from '@/components/modules/Sidebar';

// icons
import HomeIcon from '@/components/modules/icons/Home';
import ExchangeArrowIcon from '@/components/modules/icons/ExchangeArrow';
import PersonIcon from '@/components/modules/icons/Person';
import ChartLineIcon from '@/components/modules/icons/ChartLine';

export type SidebarBottomNavigationProps = {
  menuItems?: Partial<SidebarMenuItem>[];
};

const mobileMenu: Partial<SidebarMenuItem>[] = [
  { to: `/`, icon: HomeIcon },
  { to: `/exchanges`, icon: ExchangeArrowIcon },
  { to: `/portfolio`, icon: ChartLineIcon },
  { to: `/settings`, icon: PersonIcon },
];
/**
 * @component SidebarBottomNavigation
 */
function SidebarBottomNavigation({
  menuItems = mobileMenu,
}: SidebarBottomNavigationProps) {
  const renderBottomNavigationChildren = () => (
    <div className="flex items-center justify-around w-full">
      {menuItems.map((button, index) => {
        const Icon = button.icon as any;
        return (
          <NavLink href={button.to as string} key={index}>
            <div className="w-10 cursor-pointer text-gray-400 h-10 flex justify-center items-center active-link:bg-green-50 active-link:text-green-600 rounded-full">
              <Icon />
            </div>
          </NavLink>
        );
      })}
    </div>
  );
  return (
    <BottomNavigation>{renderBottomNavigationChildren()}</BottomNavigation>
  );
}

export default SidebarBottomNavigation;
